import React, { Component, Fragment } from "react";

class ShowPossibleSolutions extends Component {
  render() {
    if (this.props.exerciseSolutionData) {
      // on vérifie qu'ial y a bien des solutions d'exos qui ont été transmises à Deducer (par CalculDesPropositions par exemple), si c'est pas le cas c'est qu'on est sûrement dans Sandbox et donc cette fonction ne retourne rien
      let arrayButtonSolutions = [];

      for (let i = 0; i < this.props.exerciseSolutionData.length; i++) {
        arrayButtonSolutions.push(
          <div
            key={arrayButtonSolutions.length}
            className="solution-button"
            onClick={() => {
              this.props.valueInference.giveSolution(
                this.props.exerciseSolutionData[i].possibleSolution
              );
            }}
          >
            {i + 1}
          </div>
        );
      }
      return (
        <Fragment>
          <div style={{ fontSize: 10, color: "grey" }}>
            Solutions :
            <div className="solution-button-container">
              {arrayButtonSolutions}
            </div>
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }
}

export default ShowPossibleSolutions;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer Tools/ShowPossibleSolutions.js